import Error from '.Error';
import SyntaxError from '.SyntaxError';
import undefined from '.undefined';

import * as is from './is';
import * as TOKEN from './TOKEN';
import Options from './options';
import Layer, { protect } from './Layer';
import StyleRule from './StyleRule';
import AtRule from './@';
import KeyframesRule from './@keyframes';
import ImportRule from './@import';
import NamespaceRule from './@namespace';
import ClassSelector from './ClassSelector';
import TypeSelector from './TypeSelector';

const { merge } = TOKEN.KindMap.prototype;
const KINDS                  = [ 'type', 'class', 'attribute', 'id', 'keyframes', 'animation!keyframes', 'url' ];
function itemCallback (                                    item        , index        , items          ) {
	this.set(items[index] = item.slice(1), []);
}
function CLASS_LAYER_CB (                                                              CLASS_LAYERS                 , item        ) {
	this[this.length] = CLASS_LAYERS[CLASS_LAYERS.length] = new ClassSelector(item);
}
const replace = (sheet       , callback                                                                    , kinds                        ) => {
	const refs = sheet[REFS];
	if ( !refs ) { return; }
	let typeMap                                     = null;
	let classMap                                      = null;
	let TYPE_LAYERS                ;
	let CLASSES_LAYERS                              ;
	if ( typeof kinds==='string' ) { kinds = [ kinds ]; }
	let index = kinds.length;
	while ( index ) {
		const kind = kinds[--index] ;
		switch ( kind ) {
			case 'type':
			case 'class':
			case 'attribute': {
				const ref = refs[kind];
				if ( !ref ) { continue; }
				const attribute = kind==='attribute';
				for ( const { 0: literal, 1: layers } of ref ) {
					let ret = callback(literal, kind);
					if ( ret===undefined ) { continue; }
					if ( !TOKEN.isCompoundSelector(ret) ) { throw Error(`${kind==='attribute' ? 'attributeSelector(“[' : kind==='class' ? 'classSelector(“.' : 'typeSelector(“'}${literal}${kind==='attribute' ? ']' : ''}”)只能替换为 typeSelector 和/或 classSelector，而非“${ret}”`); }
					const items           = ret.match(TOKEN.SIMPLE_SELECTORS)                           ;
					let namespace                = null;
					let elementName         = '';
					if ( items[0] [0]!=='.' ) {
						if ( items[0] [0]==='|' ) {
							namespace = '';
							elementName = items.shift() .slice(1);
						}
						else if ( items.length===2 || items[1] [0]!=='|' ) { elementName = items.shift() ; }
						else {
							namespace = items.shift() ;
							elementName = items.shift() .slice(1);
						}
					}
					TYPE_LAYERS = [];
					items.forEach(itemCallback, CLASSES_LAYERS = new TOKEN.KindMap);
					const { length } = layers;
					let index = 0;
					do {
						const selectors                                                         = elementName ? [ new TypeSelector(elementName, namespace) ] : [];
						CLASSES_LAYERS.forEach(CLASS_LAYER_CB, selectors);
						const layer = layers[index] ;
						if ( attribute && layer.length ) { throw Error(`不能替换有值的 attributeSelector（“${layer}”）`); }
						else { layer.replaceWith(selectors); }
					}
					while ( ++index!==length );
					elementName && ( typeMap ?? ( typeMap = new TOKEN.KindMap ) ).merge(TYPE_LAYERS, namespace===null ? elementName : namespace + '|' + elementName);
					items.length && CLASSES_LAYERS.forEach(merge, classMap ?? ( classMap = new TOKEN.KindMap ));
					ref.delete(literal);
				}
				break;
			}
			case 'id': {
				const { id } = refs;
				if ( !id ) { continue; }
				let { size } = id;
				for ( const { 0: literal, 1: layers } of id ) {
					let ret = callback(literal, kind);
					if ( ret===undefined ) { continue; }
					if ( !TOKEN.isIdSelector(ret) ) { throw Error(`idSelector(“#${literal}”)只能替换为 idSelector，而非“${ret}”`); }
					id.set(ret = ret.slice(1), layers);
					let index = layers.length;
					while ( index ) { layers[--index] .valueLiteral = ret; }
					id.delete(literal);
					if ( !--size ) { break; }
				}
				break;
			}
			case 'keyframes':
			case 'animation!keyframes': {
				const { animationKeyframes } = refs;
				if ( !animationKeyframes ) { continue; }
				let { size } = animationKeyframes;
				const keyframes = kind==='keyframes';
				for ( const { 0: literal, 1: layers } of animationKeyframes ) {
					if ( keyframes===!layers.rule ) { continue; }
					const ret = callback(literal, kind);
					if ( ret===undefined ) { continue; }
					animationKeyframes.set(ret, layers);
					let index = layers.length;
					while ( index ) { layers[--index] .literal = ret; }
					const { rule } = layers;
					if ( rule ) {
						let index = rule.length;
						while ( index ) { rule[--index] .nameLiteral = ret; }
					}
					animationKeyframes.delete(literal);
					if ( !--size ) { break; }
				}
				break;
			}
			case 'url': {
				const { url } = refs;
				if ( !url ) { continue; }
				let { size } = url;
				for ( const { 0: literal, 1: layers } of url ) {
					const ret = callback(literal, kind);
					if ( ret===undefined ) { continue; }
					let index = layers.length;
					if ( ( literal[0]==='"' || literal[0]==='\'' ) && ret[0]!=='"' && ret[0]!=='\'' ) {
						while ( index ) {
							const layer = layers[--index] ;
							if ( !layer.nameLiteral ) { throw Error(`引号 url“${literal}”只能替换为引号 url，而非“${ret}”`); }
							layer.valueLiteral = ret;
						}
					}
					else {
						while ( index ) { layers[--index] .valueLiteral = ret; }
					}
					url.set(ret, layers);
					url.delete(literal);
					if ( !--size ) { break; }
				}
				break;
			}
		}
	}
	if ( typeMap ) {
		refs.type
			? typeMap.forEach(merge, refs.type)
			: refs.type = typeMap;
	}
	if ( classMap ) {
		refs.class
			? classMap.forEach(merge, refs.class)
			: refs.class = classMap;
	}
};

const REFS = Symbol('refs');
let _imports_count = 0;
let _namespaces_count = 0;

export default class Sheet extends Layer                                                                  {
	
	get [Symbol.toStringTag] () { return 'Sheet'; }
	
	        [REFS]                    ;
	
	constructor (inner        ) {
		super();
		if ( !inner ) { return this; }
		TOKEN.check(inner);
		_imports_count = _namespaces_count = 0;
		try { this[REFS] = TOKEN.parse(this, inner); }
		finally { TOKEN.clear(); }
		return this;
	}
	
	[TOKEN.consume] (           ) {
		switch ( TOKEN.type ) {
			case TOKEN.whitespace:
			case TOKEN.comment:
				return this;
			case TOKEN.atKeyword:
				const keywordLiteral = TOKEN.literal.slice(1);
				if ( is.charset (keywordLiteral) ) {
					if ( this.length ) { break; }
					throw SyntaxError(`@charset`);
				}
				if ( is.import (keywordLiteral) ) {
					if ( this.length!==_imports_count ) { break; }
					++_imports_count;
					return this.newItem = new ImportRule(keywordLiteral);
				}
				if ( is.namespace (keywordLiteral) ) {
					if ( this.length!==_imports_count + _namespaces_count ) { break; }
					++_namespaces_count;
					return this.newItem = new NamespaceRule(keywordLiteral);
				}
				return this.newItem = new ( is.keyframes (keywordLiteral) ? KeyframesRule : AtRule )(keywordLiteral);
			case TOKEN.ident:
			case '[':
			case '.':
			case '*':
			case ':':
			case '|':
			case TOKEN.hash:
				TOKEN.stay();
				return this.newItem = new StyleRule;
		}
		return null;
	}
	
	[Symbol.toPrimitive] (           ) {
		if ( this.length ) {
			const cssText = this.join('');
			return cssText[cssText.length - 1]===';' ? cssText.slice(0, -1) : cssText;
		}
		return '';
	}
	
	* [Symbol.iterator] (             options          )                                {
		Options(options);
		const { length } = this;
		let index = 0;
		while ( index!==length ) { yield * this[index++] ; }
	}
	
	                             
	
	static default = protect(this);
	
	//////treeShake (this :Sheet, selectorList :string) {}
	
	replace (             callback                                                                    , kinds                         = KINDS)       {
		replace(this, (literal        , kind       ) => callback(TOKEN.evaluate(literal), kind), kinds);
	}
	
	forEach (             callback                                                         , kinds                         = KINDS)       {
		replace(this, (literal        , kind       ) => void callback(literal, kind), kinds);
	}
	
	findGlobal (             isScoped                                                  )                {
		if ( this[REFS] && this[REFS] .selector ) {
			const selectorLists = this[REFS] .selector ;
			const { length } = selectorLists;
			let index = 0;
			while ( index!==length ) {
				const selectorList = selectorLists[index++] ;
				const { length } = selectorList;
				let i = 0;
				do { if ( !selectorList[i] .containsScope(isScoped) ) { return '' + selectorList[i] ; } }
				while ( ++i!==length );
			}
		}
	}
	
};

                                       